import { Injectable, inject } from '@angular/core';
import { DetailedContactFormGroup } from './detailed-contact-form-group.interface';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { phoneNumberValidator } from '../../validators/phone-number-validator';

@Injectable()
export class DetailedContactFormModel {
  readonly fieldNames = {
    name: 'name',
    surname: 'surname',
    patronymic: 'patronymic',
    position: 'position',
    birthDate: 'birthDate',
    phoneNumber: 'phoneNumber',
    email: 'email',
    responsibleUserId: 'responsibleUserId',
    organizationId: 'organizationId',
    isCustomer: 'isCustomer',
    isVendor: 'isVendor',
    contactType: 'contactType',
  };

  form: FormGroup<DetailedContactFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<DetailedContactFormGroup>({
      name: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(128)],
      }),
      surname: new FormControl(null, Validators.maxLength(128)),
      patronymic: new FormControl(null, Validators.maxLength(128)),
      position: new FormControl(null, Validators.maxLength(128)),
      birthDate: new FormControl<string | null>(null),
      phoneNumber: new FormControl<string | null>(null, {
        validators: [phoneNumberValidator],
      }),
      email: new FormControl(null, [Validators.email]),
      responsibleUserId: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      organizationId: new FormControl(null),
      isCustomer: new FormControl(false, { nonNullable: true }),
      isVendor: new FormControl(false, { nonNullable: true }),
      contactType: new FormControl({ isCustomer: false, isVendor: false }, { nonNullable: true }),
    });
  }
}
